"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ColumnConfig_1 = tslib_1.__importDefault(require("../column-config/ColumnConfig"));
const fmko_ts_common_1 = require("fmko-ts-common");
class SchemaColumnConfig extends ColumnConfig_1.default {
    constructor({ heading, headerStyle, mapDataToTD, mapDataToTDCssClasses, mapDataToSortValue, sortable, clickable, footers, canFilter, wordWrap, bolded }) {
        super({
            heading,
            headerStyle,
            mapDataToTD,
            mapDataToTDCssClasses,
            mapDataToSortValue,
            sortable: sortable ?? false,
            clickable,
            footers,
            canFilter,
            wordWrap,
            bolded
        });
    }
    setCellElementEnabled(cellElement, enabled) {
        fmko_ts_common_1.DOM.setElementTabbable(cellElement, enabled);
        fmko_ts_common_1.DOM.setElementEnabled(cellElement, enabled);
    }
}
exports.default = SchemaColumnConfig;
//# sourceMappingURL=SchemaColumnConfig.js.map